<mat-card class="no-overflow confirm-dialog">
  <mat-card-header class="flex-start">
    <mat-card-title>{{ data.title }}</mat-card-title>
  </mat-card-header>

  <mat-card-content class="padding all">
    <div class="wrapper">
      <div class="row">
        <div class="col">
          <!-- <phx-warning *ngIf="!data.successMsg && data.message" [text]="data.message"></phx-warning> -->
          <div class="warning-box" *ngIf="!data.successMsg && data.message">
            <div class="warning-box-items">
              <mat-icon class="warning">warning</mat-icon>
              <div class="text">
                {{ data.message }}
              </div>
            </div>
          </div>
          <div class="row" *ngIf="data.successMsg">{{ data.message }}</div>
        </div>
      </div>

      <!-- Confirm Form -->
      <form [formGroup]="confirmForm" autocompete="off" *ngIf="data.reasonRequired" (keyup.enter)="confirmSelected()">
        <div class="section margin top lg">
          <!-- Reason -->
          <div class="row">
            <mat-form-field>
              <mat-label
                [ngClass]="{
                  'error-message': fieldHasError(confirmForm, 'reason'),
                  focus: focus.reason
                }"
                >Reason</mat-label
              >

              <div
                class="form-input"
                [ngClass]="{
                  error: fieldHasError(confirmForm, 'reason'),
                  'focus-border': focus.reason
                }"
              >
                <input
                  id="reason"
                  placeholder="Enter Reason for action"
                  formControlName="reason"
                  (focus)="focusOn('reason')"
                  (focusout)="focusOn('reason')"
                  autocomplete="no"
                  cdkFocusInitial
                  matInput
                  aria-describedby="Reason for action"
                />

                <mat-icon *ngIf="fieldHasError(confirmForm, 'reason')" [size]="24" [color]="'#EE6352'"
                  >warning
                </mat-icon>
              </div>

              <!-- Errors -->
              <div *ngFor="let validation of errorMessages.reason">
                <div
                  class="caption error-message"
                  *ngIf="fieldHasErrorMessages(confirmForm, validation, 'reason')"
                  id="reasonErrors"
                >
                  {{ validation.message }}
                </div>
              </div>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>

  <mat-card-action>
    <div class="row flex-end">
      <button id="btn-cancel" class="margin left" mat-stroked-button *ngIf="data.showCancel" (click)="cancelSelected()">
        {{ data.cancel }}
      </button>

      <button
        id="btn-confirm"
        class="margin left"
        [color]="data.confirmColor"
        mat-flat-button
        (click)="confirmSelected()"
        [disabled]="!confirmForm.valid && data.reasonRequired"
      >
        {{ data.confirm }}
      </button>
    </div>
  </mat-card-action>
</mat-card>
